module.exports = __webpack_public_path__ + "ed134c3ca3b4992382d38366586c11da.jpg";